/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, TextFormat, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './hospital-payment.reducer';

export const HospitalPayment = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const hospitalPaymentList = useAppSelector(state => state.hospitalPayment.entities);
  const loading = useAppSelector(state => state.hospitalPayment.loading);
  const totalItems = useAppSelector(state => state.hospitalPayment.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="hospital-payment-heading" data-cy="HospitalPaymentHeading">
        <Translate contentKey="tinyMedicRestApp.hospitalPayment.home.title">Hospital Payments</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.hospitalPayment.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/hospital-payment/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.hospitalPayment.home.createLabel">Create new Hospital Payment</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.hospitalPayment.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {hospitalPaymentList && hospitalPaymentList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('writtenOn')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.writtenOn">Written On</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('writtenOn')} />
                </th>
                <th className="hand" onClick={sort('toRealizeOn')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.toRealizeOn">To Realize On</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('toRealizeOn')} />
                </th>
                <th className="hand" onClick={sort('paymentMethod')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.paymentMethod">Payment Method</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('paymentMethod')} />
                </th>
                <th className="hand" onClick={sort('realized')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.realized">Realized</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('realized')} />
                </th>
                <th className="hand" onClick={sort('realizedOn')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.realizedOn">Realized On</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('realizedOn')} />
                </th>
                <th className="hand" onClick={sort('realizationComments')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.realizationComments">Realization Comments</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('realizationComments')} />
                </th>
                <th className="hand" onClick={sort('comments')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.comments">Comments</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('comments')} />
                </th>
                <th className="hand" onClick={sort('chequeRefNo')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.chequeRefNo">Cheque Ref No</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('chequeRefNo')} />
                </th>
                <th className="hand" onClick={sort('chequeDate')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.chequeDate">Cheque Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('chequeDate')} />
                </th>
                <th className="hand" onClick={sort('creditCardRefNo')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.creditCardRefNo">Credit Card Ref No</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('creditCardRefNo')} />
                </th>
                <th className="hand" onClick={sort('transactionRefNo')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.transactionRefNo">Transaction Ref No</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('transactionRefNo')} />
                </th>
                <th className="hand" onClick={sort('paidValue')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.paidValue">Paid Value</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('paidValue')} />
                </th>
                <th className="hand" onClick={sort('insuranceRefNo')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.insuranceRefNo">Insurance Ref No</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('insuranceRefNo')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('paymentStatus')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.paymentStatus">Payment Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('paymentStatus')} />
                </th>
                <th className="hand" onClick={sort('billOrigin')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.billOrigin">Bill Origin</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('billOrigin')} />
                </th>
                <th className="hand" onClick={sort('collectedById')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.collectedById">Collected By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('collectedById')} />
                </th>
                <th className="hand" onClick={sort('collectedByType')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.collectedByType">Collected By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('collectedByType')} />
                </th>
                <th className="hand" onClick={sort('lastUpdatedById')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.lastUpdatedById">Last Updated By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdatedById')} />
                </th>
                <th className="hand" onClick={sort('gatewayVendor')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.gatewayVendor">Gateway Vendor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('gatewayVendor')} />
                </th>
                <th className="hand" onClick={sort('accountOrCardNo')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.accountOrCardNo">Account Or Card No</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('accountOrCardNo')} />
                </th>
                <th className="hand" onClick={sort('accountHolderName')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.accountHolderName">Account Holder Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('accountHolderName')} />
                </th>
                <th className="hand" onClick={sort('cardExpiryDate')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.cardExpiryDate">Card Expiry Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cardExpiryDate')} />
                </th>
                <th className="hand" onClick={sort('voided')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.voided">Voided</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('voided')} />
                </th>
                <th className="hand" onClick={sort('voidedReason')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.voidedReason">Voided Reason</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('voidedReason')} />
                </th>
                <th className="hand" onClick={sort('voidedDate')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.voidedDate">Voided Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('voidedDate')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.insuranceOrBank">Insurance Or Bank</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.cashTransaction">Cash Transaction</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.claim">Claim</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.admission">Admission</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.bill">Bill</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.hospitalPayment.subscriber">Subscriber</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {hospitalPaymentList.map((hospitalPayment, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/hospital-payment/${hospitalPayment.id}`} color="link" size="sm">
                      {hospitalPayment.id}
                    </Button>
                  </td>
                  <td>
                    {hospitalPayment.writtenOn ? (
                      <TextFormat type="date" value={hospitalPayment.writtenOn} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {hospitalPayment.toRealizeOn ? (
                      <TextFormat type="date" value={hospitalPayment.toRealizeOn} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PaymentMethod.${hospitalPayment.paymentMethod}`} />
                  </td>
                  <td>{hospitalPayment.realized ? 'true' : 'false'}</td>
                  <td>
                    {hospitalPayment.realizedOn ? (
                      <TextFormat type="date" value={hospitalPayment.realizedOn} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{hospitalPayment.realizationComments}</td>
                  <td>{hospitalPayment.comments}</td>
                  <td>{hospitalPayment.chequeRefNo}</td>
                  <td>
                    {hospitalPayment.chequeDate ? (
                      <TextFormat type="date" value={hospitalPayment.chequeDate} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{hospitalPayment.creditCardRefNo}</td>
                  <td>{hospitalPayment.transactionRefNo}</td>
                  <td>{hospitalPayment.paidValue}</td>
                  <td>{hospitalPayment.insuranceRefNo}</td>
                  <td>{hospitalPayment.active ? 'true' : 'false'}</td>
                  <td>
                    {hospitalPayment.microSec ? <TextFormat type="date" value={hospitalPayment.microSec} format={APP_DATE_FORMAT} /> : null}
                  </td>
                  <td>
                    {hospitalPayment.timestampEntry ? (
                      <TextFormat type="date" value={hospitalPayment.timestampEntry} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {hospitalPayment.lastUpdated ? (
                      <TextFormat type="date" value={hospitalPayment.lastUpdated} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{hospitalPayment.cursor}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PaymentStatus.${hospitalPayment.paymentStatus}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.BillOrigin.${hospitalPayment.billOrigin}`} />
                  </td>
                  <td>{hospitalPayment.collectedById}</td>
                  <td>{hospitalPayment.collectedByType}</td>
                  <td>{hospitalPayment.lastUpdatedById}</td>
                  <td>{hospitalPayment.gatewayVendor}</td>
                  <td>{hospitalPayment.accountOrCardNo}</td>
                  <td>{hospitalPayment.accountHolderName}</td>
                  <td>{hospitalPayment.cardExpiryDate}</td>
                  <td>{hospitalPayment.voided ? 'true' : 'false'}</td>
                  <td>{hospitalPayment.voidedReason}</td>
                  <td>{hospitalPayment.voidedDate}</td>
                  <td>
                    {hospitalPayment.insuranceOrBank ? (
                      <Link to={`/institution/${hospitalPayment.insuranceOrBank.id}`}>{hospitalPayment.insuranceOrBank.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {hospitalPayment.cashTransaction ? (
                      <Link to={`/cash-transaction/${hospitalPayment.cashTransaction.id}`}>{hospitalPayment.cashTransaction.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {hospitalPayment.claim ? (
                      <Link to={`/insurance-claim/${hospitalPayment.claim.id}`}>{hospitalPayment.claim.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {hospitalPayment.admission ? (
                      <Link to={`/admission/${hospitalPayment.admission.id}`}>{hospitalPayment.admission.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {hospitalPayment.bill ? <Link to={`/hospital-bill/${hospitalPayment.bill.id}`}>{hospitalPayment.bill.id}</Link> : ''}
                  </td>
                  <td>
                    {hospitalPayment.subscriber ? (
                      <Link to={`/package-subscriber/${hospitalPayment.subscriber.id}`}>{hospitalPayment.subscriber.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/hospital-payment/${hospitalPayment.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/hospital-payment/${hospitalPayment.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/hospital-payment/${hospitalPayment.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.hospitalPayment.home.notFound">No Hospital Payments found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={hospitalPaymentList && hospitalPaymentList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default HospitalPayment;
